"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const React = tslib_1.__importStar(require("react"));
const __1 = tslib_1.__importDefault(require(".."));
const Caption = React.forwardRef((_a, ref) => {
    var { as = 'figcaption', children } = _a, props = tslib_1.__rest(_a, ["as", "children"]);
    return ((0, jsx_runtime_1.jsx)(__1.default, Object.assign({ as: as, ref: ref, size: 'xxs' }, props, { children: children })));
});
exports.default = Caption;
